import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "./AuthContext";

const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
  // Able to access to currentUser variable from Auth component
  const { contextUsername } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        !!contextUsername ? (
          <RouteComponent {...routeProps} />
        ) : (
          <Redirect to={"/login"} />
        )
      }
    />
  );
};

export default PrivateRoute;
